import React, { useState, useEffect } from 'react'
// import PropTypes from 'prop-types'
import { Button, Divider, Box, Typography, Grid } from '@material-ui/core'
import Select from 'react-select'
import { useStyles } from '../styles'
// components
import Workforce from './Workforce'
import HiringForecastFormDlg from './HiringForecastFormDlg'


export default function HiringForecastDlg(props) {

	const classes = useStyles()

	const [openForecastForm, setOpenForecastForm] = useState(false)
	const [selectedForecast, setSelectedForecast] = useState(props.selectedForecast)

	const hiringForeCastCreated = () => {
		// fetch all hiring forecasts
		// make latest hiring forecast selected
		setOpenForecastForm(false)
		props.hiringForecastCreated()
	}

	useEffect(() => {
		setSelectedForecast(props.selectedForecast)
	},[props.selectedForecast])

    return (
        <>
			<Grid container direction='row' justify='center' alignItems='center'>
				<Grid item>
					<Button variant='contained' color='primary' onClick={() => setOpenForecastForm(true)}>Create a new Hiring Forecast</Button>
				</Grid>
				<Grid item xs={4} className={classes.selectionOR}>
					<Typography variant='h6'>OR</Typography>
				</Grid>
				<Grid item>
					{/* <Typography display='inline'>Select Existing Forecast</Typography> */}
					<div className={classes.forecastSelectionArea}>
						<Select
							placeholder={'Select Existing Forecast'}
							value={selectedForecast}
							onChange={(selectedForecastOption) => setSelectedForecast(selectedForecastOption)}
							options={props.forecastOptions}
							styles={{
								menu: (styles) => {
									return {
										...styles,
										zIndex: 1000
									}
								}
							}}
						/>
					</div>
				</Grid>
			</Grid>

			<Box mt={2} />
			<Divider />
			<Box mt={2} />
			{
				props.forecastOptions.length > 0 ?
					<>
						<Workforce
							selectedForecast={selectedForecast}
							masterData={props.masterData}
						/>
					</>
					:
					null
			}
			<HiringForecastFormDlg
				isOpen={openForecastForm}
				onClose={() => setOpenForecastForm(false)}
				onSuccess={() => hiringForeCastCreated()}
			/>
        </>
    )
}

